import React from 'react';
import {AppConsumer} from '../../AppContext';
import makeAPICallz from '../api';
import {INTERNET_NOT_CONNECTED} from '../request';
import {RESCOUNTRYID, getPrefData} from '../../storage/preferenceStorage';
import {COUNTRY_USA} from '../../utils/countryCode';
import {createRequestIds} from '../../utils';
// import {encodeBase64} from '../../utils/jsEncrypt';
let rescountryId = '';
let jsonResponseVal = '';
const getCountryId = async () => {
  rescountryId = await getPrefData(RESCOUNTRYID);
};
const hocWithFetcher = Component => {
  return class extends React.Component {
    static contextType = AppConsumer;

    constructor(props) {
      super(props);
      this.state = {
        data: null,
        isLoading: false,
        error: null,
        id: 0,
        requestIDs: []
      };
    }

    changeRequestId = txnId => {
      var secret = '';
      var latest = this.state.requestIDs.filter(function(val) {
        if (val.requestId === txnId) {
          secret = val.secret.substring(0, val.secret.length - val.requestId.length);
          return false;
        }
        return true;
      });
      this.setState({requestIDs: latest});
      return secret;
    };

    makeAPICall = (request, successCallback, failureCallback, loadingCallback) => {
      const loadingFunc = typeof loadingCallback === 'function';
      const receiveResponseFunc = typeof successCallback === 'function';
      const errorFunc = typeof failureCallback === 'function';
      var secret =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      let requestIds = createRequestIds(this.state.id, secret);

      if (request.payload == '') request.payload = {};
      request.payload.requestId = requestIds.requestId;

      this.setState(prevState => ({
        requestIDs: [...prevState.requestIDs, requestIds],
        id: prevState.id + 1
      }));

      const {ShowToast} = this.context;
      getCountryId();
      loadingFunc
        ? loadingCallback(true)
        : this.setState({isLoading: true}, function() {
            // console.log('loading> ', this.state.isLoading, request);
          });
      makeAPICallz(request, this.changeRequestId, secret)
        .then(result => {
          const jsonResponse = result.data; //JSON.parse(result.data);
          jsonResponse.tag = result.tag;

          if (receiveResponseFunc && loadingFunc) {
            successCallback(jsonResponse);
            loadingCallback(false);
          } else if (receiveResponseFunc) {
            this.setState(
              {
                isLoading: false
              },
              function() {
                successCallback(jsonResponse);
              }
            );
          } else if (loadingFunc) {
            loadingCallback(false);
            this.setState({
              data: jsonResponse
            });
          } else {
            this.setState({
              data: jsonResponse,
              isLoading: false
            });
          }
        })
        .catch(error => {
          // console.log('erro', error);
          // TODO: handle all common error scenarios here
          if (error.code === 401 || error.code === 403 || error.code === 405 || error.code === 406) {
            const {navigation} = this.props;
            if (navigation) {
              ShowToast({
                showToast: true,
                message: error.message || 'Logged out due to inactivity',
                duration: 6000,
                align: 'center',
                top: 'top',
                errortype: 'error'
              });
              navigation.navigate('Logout');
            }
            return;
          }
          if (error.code === 500) {
            ShowToast({
              showToast: true,
              message: 'Unable to process the request, please try after some time',
              duration: 6000,
              align: 'center',
              top: 'top',
              errortype: 'error'
            });
          }

          if (error.code === INTERNET_NOT_CONNECTED) {
            ShowToast({
              showToast: true,
              message: 'Please check internet connection, we are unable to reach our servers',
              duration: 6000,
              align: 'center',
              top: 'top',
              errortype: 'error'
            });
          }

          if (errorFunc && loadingFunc) {
            failureCallback(error);
            loadingCallback(false);
          } else if (errorFunc) {
            failureCallback(error);
            this.setState({
              isLoading: false
            });
          } else if (loadingFunc) {
            loadingCallback(false);
            this.setState({
              error
            });
          } else {
            this.setState({
              error,
              isLoading: false
            });
          }
        });
    };

    showLoader = () => {
      this.setState({isLoading: true});
    };

    hideLoader = () => {
      this.setState({isLoading: false});
    };

    render() {
      return <Component registerDataReceived={this.registerDataReceived} registerLoading={this.registerLoading} registerError={this.registerError} makeAPICall={this.makeAPICall} showLoader={this.showLoader} hideLoader={this.hideLoader} {...this.props} {...this.state} />;
    }
  };
};

export {hocWithFetcher};
